import user from "@/router/middlewares/auth";
import Vue from "vue";
import store from "@/store/store";

export default {
  guest(to, from, next) {
    next(!user.check());
  },

  // auth flow example: http://vue-router-demos.surge.sh/#/examples/auth-flow
  auth(to, from, next) {
    console.log("called");

    if (localStorage.getItem("access_token") == null) next({ path: "/login" });

    if (store.state.auth.userInfo !== null) next();

    store
      .dispatch("getUserInfo")
      .then(response => {
        // console.log(response)
        next();
      })
      .catch(error => {
        localStorage.removeItem("access_token");
        next({
          path: "/login",
          query: { redirect: to.fullPath }
        });
      });
  },

  checkPermissionsVideographer(to, from, next) {
    var userInfo = store.state.auth.userInfo;

    if (userInfo !== null) {
      console.log(userInfo.role);

      if (
        userInfo.role !== null &&
        userInfo.role !== "media_purchaser" &&
        userInfo.role !== "media_producer"
      ) {
        next();
        return;
      }
    }

    next({ path: "/401" });
  },

  checkRoleSocialMedia(to, from, next) {
    var userInfo = store.state.auth.userInfo;

    if (userInfo !== null) {
      console.log(userInfo.role);

      if (userInfo == undefined) next({ path: "/401" });
      const filtered = userInfo.roles.filter(role => {
        return role.name.toLowerCase().includes("social");
      });

      if (filtered.length == 1) {
        next();
        return;
      }
    }

    next({ path: "/401" });
  },

  checkPermissionsAdministrator(to, from, next) {
    var userInfo = store.state.auth.userInfo;

    if (userInfo !== null) {
      if (
        userInfo.role !== null &&
        (userInfo.role == "administrator" ||
          userInfo.role == "superadministrator")
      ) {
        next();
        return;
      }
    }

    next({ path: "/401" });
  },

  checkPermissionsSuperAdministrator(to, from, next) {
    var userInfo = store.state.auth.userInfo;

    if (userInfo !== null) {
      if (userInfo.role !== null && userInfo.role == "superadministrator") {
        next();
        return;
      }
    }

    next({ path: "/401" });
  },

  checkPermissionsOwner(to, from, next) {
    console.log('> checkPermissionsOwner')
    console.log(store.state.auth.userInfo)
    var userInfo = store.state.auth.userInfo;

    // if(userInfo.roles == null) return false
    if(userInfo.roles.some(role => role.id === 0)) {
      next();
      return;
    }

    next({ path: "/401" });
  },

  checkPermissionsMedia(to, from, next) {
    var userInfo = store.state.auth.userInfo;
    console.log("userInfo");
    if (userInfo !== null) {
      if (
        userInfo.role !== null &&
        (userInfo.role == "media_purchaser" ||
          userInfo.role == "media_producer" ||
          userInfo.role == "superadministrator" ||
          userInfo.role == "administrator")
      ) {
        next();
        return;
      }
    }

    next({ path: "/401" });
  },

  preventLoginAccessIfLoggedIn(to, from, next) {
    if (
      localStorage.getItem("access_token") !== null &&
      store.state.auth.userInfo !== null
    ) {
      next({ path: "/stringer/home" });

      return;
    } else {
      if (localStorage.getItem("access_token") !== null) {
        store
          .dispatch("getUserInfo")
          .then(response => {
            // console.log(response)
            next();
          })
          .catch(error => {
            localStorage.removeItem("access_token");
            next({ path: "/login" });
          });
      }
    }

    next();
  },

  goToDashboard(to, from, next) {
    var permission = store.state.auth.userInfo.role;

    if (permission == "videographer") {
      next({ path: "/stringer/home" });
    }

    if (permission == "superadministrator" || permission == "administrator") {
      next({ path: "/admin/dashboard" });
    }

    if (permission == "media_producer" || permission == "media_purchaser") {
      next({ path: "/media/latest" });
    }

    next();
  },

  verifyUserNotSuspended(to, from, next) {
    var suspended = store.state.auth.userInfo.suspended;

    console.log(suspended);

    if (suspended) {
      next({ path: "/suspended" });
      localStorage.removeItem("access_token");
    }

    next();
  },

  verifyUserAcceptedTerms(to, from, next) {
    var accepted = store.state.auth.userInfo.tos_accepted;
    console.log(accepted);

    if (accepted == 0) {
      next({ name: "FinalizeTerms" });
    }

    next();
  }
};
